import { BufferTime, BufferTimeSearch, SearchBufferTimeResponseBufferTimeTableConnectionArgs } from '@/models/gen/graphql';
import {
  ConnectionDetails,
  HandleErrorInput,
  convertConnectionToDetails,
  handleError,
  mergeConnectionDetails as merge,
} from '@/utils/custom';
import { ConnectionOptions, GraphApiMethod } from '@/api/core';
import createGraphApiHook, { CreateGraphApiHookHook } from '@/hooks/createGraphApiHook';

import { SearchBufferTimesDocument } from '@/api/queries';
import { TypedDocumentNode } from '@apollo/client';
import { getProperty } from '@/utils';
import graphApi from '@/api';

// Global Service Variables
const mergeKey = 'searchBufferTimes.bufferTimeTableConnection';
const onError = (res: HandleErrorInput): void => handleError(res, { notification: { title: 'Search Buffer Times' } });

// Service Function Signature
type ServiceMethodPayload = {
  [key in keyof BufferTimeSearch]?: any;
}[];
interface ServiceMethod {
  (payload?: ServiceMethodPayload, options?: ConnectionOptions): Promise<ConnectionDetails<BufferTime>>;
}

// SearchBufferTimes Service
export const { searchBufferTimes, refetchBufferTime, useSearchBufferTimes } = ((): {
  searchBufferTimes: ServiceMethod;
  refetchBufferTime: ServiceMethod;
  useSearchBufferTimes: CreateGraphApiHookHook<ServiceMethod>;
} => {
  const [fetch, refetch] = graphApi(SearchBufferTimesDocument, {
    onError,
  }).map(
    (fn: GraphApiMethod<TypedDocumentNode>): ServiceMethod =>
      async (payload?: ServiceMethodPayload, options?: ConnectionOptions): Promise<ConnectionDetails<BufferTime>> => {
        const args: SearchBufferTimeResponseBufferTimeTableConnectionArgs = {
          input: {
            first: options?.pageSize || null,
            after: options?.pageSize > 0 ? (options?.pageSize * options?.page).toString() : null,
            query: payload,
          },
        };
        const opts = { merge: options?.merge ? mergeKey : undefined };
        const res = await fn(args, opts);
        return convertConnectionToDetails(getProperty(mergeKey, res));
      }
  );
  const useService = createGraphApiHook(fetch, { refetch, merge });
  return {
    searchBufferTimes: fetch,
    refetchBufferTime: refetch,
    useSearchBufferTimes: useService,
  };
})();
